import { render, staticRenderFns } from "./LaneClosureRequestBlockAdd.vue?vue&type=template&id=966225b2&"
import script from "./LaneClosureRequestBlockAdd.vue?vue&type=script&lang=js&"
export * from "./LaneClosureRequestBlockAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports